import LanguagesService from 'api/languages/languagesService';

export default {
    namespaced: true,
    state() {
        return {
            languages: [],
        };
    },
    getters: {
        languages: (state) => state.languages,
    },
    mutations: {
        setLanguages(state, payload) {
            state.languages = payload;
        },
    },
    actions: {
        fetchLanguages({ commit }) {
            return new Promise((resolve, reject) => {
                LanguagesService.getAllLanguages()
                    .then((response) => {
                        commit('setLanguages', response);
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
